<template>
  <div class="searchIndex wrapper">
    <div class="ques-detail detail-container" :style="{ borderColor: borderColor }">
      <fieldset
        :id="type + question.Data.ID"
        class="quesborder left"
        s="math"
        @click="openOrCloseDetail"
        :style="{ borderColor: borderColor }">
        <div class="content">
          <div class="pt1">
            <a href="#">{{ question.Data.Label }}</a>
            <span v-html="question.Data.Content"></span>
          </div>
          <div class="pt2" v-if="question.Options && question.Options.length > 0">
            <ul style="width: 100%" class="ques quesborder que-options" :data-cols="1">
              <li class="selectoption" v-for="(option, index) in question.Options" :key="'option' + index">
                <label class="QA-options">
                  <input
                    name="QA-options"
                    :id="'QA-options' + index"
                    :value="index"
                    type="radio"
                    class="radio"
                    :checked="question.Answers && question.Answers.indexOf(index + '') != -1"
                    disabled="disabled" />
                  {{ optNums[index] + " . " }}
                  <span v-html="option"></span>
                </label>
              </li>
            </ul>
          </div>
        </div>

        <div v-show="openDetail">
          <div v-if="question.QuestionPoints && question.QuestionPoints.length > 0" class="pt3">
            <!--B3-->
            <em>【考点】</em>
            <a v-for="point in question.QuestionPoints" :key="'que-point' + point.Key" :href="'#' + point.Key">
              {{ point.Value }}、
            </a>
          </div>
          <div v-if="question.QuestionTopics && question.QuestionTopics.length > 0" class="pt4">
            <!--B4-->
            <em>【专题】</em>
            <a v-for="topic in question.QuestionTopics" :key="'que-topic' + topic.Key" :href="'#' + topic.Key">
              {{ topic.Value }}、
            </a>
          </div>
          <div v-if="question.Answers && question.Answers.length > 0" class="pt11">
            <!--B4-->
            <em>【答案】</em>
            <div v-html="question.Data.DisplayAnswer"></div>
          </div>
          <div v-if="question.Data.Analyse" class="pt5">
            <!--B5-->
            <em>【分析】</em>
            <div v-html="question.Data.Analyse"></div>
          </div>
          <div v-if="question.Data.Method" class="pt6">
            <!--B6-->
            <em>【解答】</em>
            <div v-html="question.Data.Method"></div>
          </div>
          <div v-if="question.Data.Discuss" class="pt7">
            <!--B7-->
            <em>【点评】</em>
            <div v-html="question.Data.Discuss"></div>
          </div>
        </div>
      </fieldset>
      <div class="right">
        <div class="correct">
          <div class="" :style="{ color: borderColor }">
            <span>正确率：{{ analysisData.CorrectRate }} %</span>
          </div>
          <div class="">
            <span>{{ analysisData.RightNum }}人对 | {{ analysisData.TotalNum }}人答题</span>
          </div>
        </div>

        <div class="students">
          <div class="student_list">
            <span class="tip">作错：</span>
            <p>
              <span class="student" v-for="(student, index) in analysisData.StudentWrong" :key="'wrong' + index">
                {{ student }}、
              </span>
            </p>
          </div>
          <div class="student_list">
            <span class="tip">作对：</span>
            <p>
              <span class="student" v-for="(student, index) in analysisData.StudentRight" :key="'right' + index">
                {{ student }}、
              </span>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/* import "../../assets/css/questionStyle.css";
import "../../assets/js/library.js"; */
export default {
  name: "QuestionPushDetail",
  props: {
    // 作业试题
    question: {},
    analysisData: {
      type: Object,
      default: function () {
        return {
          QuestionNum: 1, //题号
          QuestionID: 5690, //作业原题的id
          PushID: 1, //推题的id
          TotalNum: 1, //答题人数
          RightNum: 0, //答对人数
          ErrorNum: 1, //答错人数
          CorrectRate: 0, //正确率
          Answer: "B", //正确答案
          StudentRight: [], //答对的学生姓名
          StudentWrong: [], //答错的学生姓名
        };
      },
    },
    borderColor: {
      type: String,
      default: "#00a2e8",
    },
    type: {
      type: String,
      default: ''
    },
    openDetail: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // 选项字母数组
      optNums: ["A", "B", "C", "D", "E", "F", "G"],
    };
  },
  mounted() {
    if (this.questions && this.questions.length > 0) {
      let that = this;
      setTimeout(function () {
        that.computeOptionCols();
      }, 300);
    }
  },
  updated() {
    let that = this;
    setTimeout(function () {
      that.computeOptionCols();
    }, 300);
  },
  methods: {
    /* 展开或关闭试题解析详情 */
    openOrCloseDetail() {
      if (!this.openDetail) {
        //未展开解析详情，展开
        if (this.question.Data.DetailSaved == 1) {
          //已经有解析详情，直接展开显示
          this.openDetail = true;
        } else {
          //还未加载解析详情，先调接口获取详情后再展开显示
          this.getQueDetail();
        }
      } else {
        // 已展开，收起
        this.openDetail = false;
      }
    },
    /* 获取试题解析详情接口，更新数据 */
    getQueDetail() {
      this.axios.get(window.hosturl + "/rest/questionBank/GetQuestionAnalysis?SID=" + this.question.Data.SID)
        .then((res) => {
        if (res.data.code == 200) {
          this.question = res.data.data;
          this.openDetail = true;
        }
      });
    },

    /* 计算选择题选项li的width更新合适的展示比例 */
    computeOptionCols() {
      let colNum = 1;
      let que = this.question;
      if (que.Options && que.Options.length > 0) {
        let queDom = document.getElementById(this.type + que.Data.ID);
        let ulW = queDom.querySelector(".que-options").offsetWidth;
        let optionLis = queDom.querySelectorAll(".selectoption");
        let count = optionLis.length;
        let maxW = 0;

        for (let optionLi of optionLis) {
          // 先清除宽度设置，后面计算完之后重新赋值
          optionLi.style.width = "";
          if (optionLi.offsetWidth > maxW) {
            maxW = optionLi.offsetWidth;
          }
        }
        switch (count) {
          case 1:
            colNum = 1;
            break;
          case 2:
            if (maxW > ulW * 0.48) {
              colNum = 1;
            } else {
              colNum = 2;
            }
            break;
          case 3:
            if (maxW > ulW * 0.48) {
              colNum = 1;
            } else if (maxW > ulW * 0.32) {
              colNum = 2;
            } else {
              colNum = 3;
            }
            break;
          case 4:
            if (maxW > ulW * 0.48) {
              colNum = 1;
            } else if (maxW > ulW * 0.23) {
              colNum = 2;
            } else {
              colNum = 4;
            }
            break;
          case 5:
            if (maxW > ulW * 0.48) {
              colNum = 1;
            } else if (maxW > ulW * 0.32) {
              colNum = 2;
            } else if (maxW > ulW * 0.19) {
              colNum = 3;
            } else {
              colNum = 5;
            }
            break;
          case 6:
            if (maxW > ulW * 0.48) {
              colNum = 1;
            } else if (maxW > ulW * 0.32) {
              colNum = 2;
            } else if (maxW > ulW * 0.16) {
              colNum = 3;
            } else {
              colNum = 6;
            }
            break;
        }
        let w = (1 / colNum - 0.02) * 100 + "%";
        for (let optionLi of optionLis) {
          optionLi.style.width = w;
        }
        que.colNum = colNum;
      }
    },
  },
};
</script>
<style lang="less">
.detail-container {
  display: flex;
  margin-left: 15px;
  border: 2px solid #00a2e8;
  .left {
    width: 60%;
    border-right: 2px solid #00a2e8;
    cursor: pointer;
  }
  .right {
    width: 40%;
    padding: 10px;
    font-size: 15px;
    line-height: 36px;
    .correct {
      font-size: 16px;
      font-weight: 600;
      display: flex;
      color: #797979;
      justify-content: space-between;
    }
    .students {
      .student_list {
        position: relative;
        min-height: 36px;
        span.tip {
          position: absolute;
        }
        p {
          padding-left: 50px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/detail/QuestionPushDetail.vue